import React, {useState, useRef, forwardRef, useImperativeHandle} from 'react';
import './index.scss';
import MagentoPic from '../../../../assets/glo-magento.png';
import Form, {Item, RequiredRule, ButtonItem} from 'devextreme-react/form';
import sessions from '../../../../sessions';

const Magento = forwardRef((props, ref) => {
    const formData = useRef({});
    const userId = sessions.getSession("user")?.id;

    const onSubmit = (async(e) => {
        if(e)e.preventDefault();
    })

    useImperativeHandle(ref, (e) => ({onSubmit}));

    return (
        <React.Fragment>
             <div className="bridge-header">
                <img alt="MagentoPic" src={MagentoPic} className="logo-size"/>
            </div>
            <div className="bridge-content">
                <div className="bridge-content">
                    <form onSubmit={onSubmit}>
                        <Form formData={formData.current} className="form-field" labelLocation={'left'}>
                            <Item
                                dataField="username"
                                editorType="dxTextBox"
                                showClearButton={true}
                                editorOptions={{
                                width:200,
                                stylingMode: 'filled',
                                placeholder: ''
                            }}>
                                <RequiredRule message="username is required"/>
                            </Item>
                            <ButtonItem horizontalAlignment="left"
                            //This button help to preventdefault
                            buttonOptions={{
                                text: 'shadowButton',
                                type: 'success',
                                useSubmitBehavior: true,
                                visible:false
                            }}
                            />
                        </Form>
                    </form>
                    <br/>
                </div>
            </div>
            <div className={'bridge-footer'}>
                <p className={'etsy-disclaimer'}>Magento integration will be available to you soon</p>
            </div>
        </React.Fragment>
    );
})

export default Magento;